export const statusHandler = (response, callback) => {
  const { ok, data } = response;
  if (ok && data.status >= 200 && data.status < 300) {
    if (callback) callback(data);
    return data;
  }
  throw data;
};
